import { AxiosResponse } from 'axios';
import fetcher, { MethodEnum } from 'utils/helpers/browser/newFetcher';
import { LicenseRoleEnum, LicenseTypeApiEnum } from 'submodules/api_middleware';
import { QueryRequestInterface } from 'submodules/api_middleware/src/interfaces/InternalInterfaces';

export class LicenseService {
    async getRoleTypes(
        role: LicenseRoleEnum,
        query?: QueryRequestInterface
    ): Promise<AxiosResponse<LicenseTypeApiEnum[]>> {
        return await fetcher(
            `/api/license/${role}/types`,
            MethodEnum.GET,
            query
        );
    }
}
